import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { map, shareReplay, distinctUntilChanged, skip, takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AdminLayoutService implements OnDestroy {
  private _sidenavOpen = new BehaviorSubject<boolean>(false);
  public readonly isSidenavOpen$ = this._sidenavOpen.asObservable();

  private destroy$ = new Subject<void>();

  public readonly isHandset$: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
    // Ein einziges, geteiltes Observable für den Handset-Status.
    // shareReplay macht es "heiß", sodass alle Subscriber denselben Wert erhalten.
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset)
      .pipe(
        map(result => result.matches),
        shareReplay({ bufferSize: 1, refCount: true })
      );

    // Reagiere nur auf ÄNDERUNGEN des Handset-Status, um die Sidebar zurückzusetzen.
    this.isHandset$.pipe(
      distinctUntilChanged(), // Feuert nur, wenn sich der Wert (true/false) ändert
      skip(1), // Ignoriert den initialen Wert beim Laden der App
      takeUntil(this.destroy$)
    ).subscribe(() => {
      // Setzt die Sidebar beim Wechsel zwischen Desktop/Mobil immer auf geschlossen/minimiert.
      this._sidenavOpen.next(false);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public toggleAdminSidenav(): void {
    this._sidenavOpen.next(!this._sidenavOpen.getValue());
  }

  setAdminSidenavState(isOpen: boolean): void {
    this._sidenavOpen.next(isOpen);
  }
}
